<template>
  <v-app>
    <v-app-bar dark app class="topBarBg darken-1" elevation="0">
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="../../public/img/background/PentaWorld_Dark.png"
          transition="scale-transition"
          width="150"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn @click="logout()" text>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <v-bottom-navigation fixed>
      <v-btn value="Message" :to="{ name: 'pesan' }">
        <span>Forum</span>
        <v-icon>mdi-chat</v-icon>
      </v-btn>
      <!-- <v-btn value="Message" :to="{ name: 'about'}">
      <span>About</span>
      <v-icon>mdi-message-text</v-icon>
    </v-btn> -->
      <v-btn value="home" :to="{ name: 'home' }">
        <span>Home</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <!-- <v-btn value="performance" :to="{ name: 'mapUser'}">
      <span>Nearby</span>
      <v-icon>mdi-wrench</v-icon>
    </v-btn> -->

      <v-btn value="survey" :to="{ name: 'survey' }">
        <span>Feedback</span>
        <v-icon>mdi-message-text</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    clear: {
      id: null,
      userId: null,
      digits: "",
      fotoUrl: "",
      workType: "",
      positionTitle: "",
      lat: null,
      lon: null,
      company: "",
      noKado: null,
      getKado: null,
      roomName: "",
    },
    //
  }),
  methods: {
    logout() {
      this.$store.commit("SET_LOGIN", null);
      this.$store.commit("SET_USERINFO", this.clear);

      this.$router.push("/");
    },
  },
};
</script>

<style>
.bg-color {
  background-color: white;
}
</style>
